import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import AuthShell from "./AuthShell";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => localStorage.getItem("wn_remember_email") || "");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password, remember);
      if (remember) localStorage.setItem("wn_remember_email", email);
      else localStorage.removeItem("wn_remember_email");
      toast.success("Welcome back!");
      const next = new URLSearchParams(window.location.search).get("next");
      navigate(next || "/my-bookings");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-[#D4AF37] focus:ring-0 transition-colors duration-200";

  return (
    <AuthShell testid="login-page" title="Sign In" subtitle="Access your bookings and reserve your next cut.">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="login-email" type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
        <div className="relative">
          <input data-testid="login-password" type={showPw ? "text" : "password"} required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field + " pr-12"} />
          <button type="button" data-testid="login-password-toggle" onClick={() => setShowPw((v) => !v)} aria-label={showPw ? "Hide password" : "Show password"} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#D4AF37] transition-colors duration-200">
            {showPw ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2 text-sm text-gray-400 cursor-pointer"><input type="checkbox" data-testid="login-remember" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="accent-[#D4AF37]" /> Remember me</label>
          <Link to="/forgot-password" className="text-sm text-gray-400 hover:text-[#D4AF37]">Forgot password?</Link>
        </div>
        <button data-testid="login-submit" disabled={loading} className="w-full py-3.5 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#F3E5AB] transition-colors duration-300 disabled:opacity-60 flex items-center justify-center gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
        </button>
      </form>
      <p className="text-gray-400 text-sm mt-6 text-center">
        New here? <Link to={`/register${window.location.search}`} className="text-[#D4AF37]">Create an account</Link>
      </p>
    </AuthShell>
  );
}
